import {
  isTakeoverActive,
  getDailyConfig,
} from "../config/scoreboardTakeover";

export function getActiveDailyConfig(dateKey) {
  if (!isTakeoverActive(dateKey)) return null;
  return getDailyConfig(dateKey) || null;
}
